import { Container } from 'nonaction';
import useText from './Hooks/useText.js';
export const TextContainer = Container(useText);